import { Component, Input, computed, inject } from '@angular/core';

import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { WidgetDataStore } from '../../../../stores/widget-data.store';
import { CountWidget, CountWidgetData } from '../../models';

@Component({
  selector: 'siat-count-widget',

  imports: [MatIconModule, MatCardModule, MatButton, TranslatePipe],
  templateUrl: './count-widget.component.html',
  styleUrl: './count-widget.component.scss',
})
export class CountWidgetComponent {
  @Input() widget!: CountWidget;
  @Input() lockedPatient: boolean;

  private widgetDataStore = inject(WidgetDataStore);
  private router = inject(Router);

  // Get widget data from store reactively
  widgetData = computed(() => {
    const widget = this.widgetDataStore.getWidgetData(this.widget?.id);
    return (
      (widget as CountWidgetData) || {
        value: 0,
        label: this.widget?.title || '',
        unit: '',
      }
    );
  });

  get displayValue(): string {
    return this.widgetData()?.value?.toLocaleString() || '0';
  }

  gotTo() {
    let filter = '';
    if (this.widget.config?.filter) {
      const paramName =
        this.widget.config.filter.name === 'stato'
          ? 'stati'
          : this.widget.config.filter.name;
      filter = `?${paramName}=${this.widget.config.filter.keyword}`;
    }
    this.router.navigateByUrl(
      `/home/${this.widget.config.path.viewAll}${filter}`
    );
  }
}
